import { render } from "./ProductListOld.vue?vue&type=template&id=a956ec84&scoped=true"
import script from "./ProductListOld.vue?vue&type=script&lang=js"
export * from "./ProductListOld.vue?vue&type=script&lang=js"

import "./ProductListOld.vue?vue&type=style&index=0&id=a956ec84&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a956ec84"]])

export default __exports__